import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../utils/IDS";
import { DELETE, GET, POST } from "../utils/Methods";
import { APIS } from "../utils/APIS";
import Cookies from "js-cookie";


export const GetRiskDisclosureAgreement = createAsyncThunk(
  "about_us/GetRiskDisclosureAgreement/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AboutRiskDisclouser);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const GetConfidentialityAgreement = createAsyncThunk(
  "about_us/GetConfidentialityAgreement/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AboutConfidentialityAgreement);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const Slice = createSlice({
  name: "about_us",
  initialState: {
    data: {},

  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetRiskDisclosureAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetRiskDisclosureAgreement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || {};

      })
      .addCase(GetRiskDisclosureAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetConfidentialityAgreement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetConfidentialityAgreement.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || {};
      })
      .addCase(GetConfidentialityAgreement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      ;
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
